export class PhoneUpdateMessageConstants {
    public static HOME = 'Home';
    public static PHONE_UPDATE_TEMPLATE = '||phoneType|| Phone Number updated to ||phoneNumber||';
    public static PHONE_TYPE_UPDATE_TEMPLATE = '||oldType|| Phone to ||phoneType|| Phone';
}



// WEBPACK FOOTER //
// ./src/app/customerservice/constants/update-phone-message.contants.ts